import React from 'react';
import './Logo.css';

const Logo = () => {
  return (
    <span className='Logo' >
      <span className='highlight'>k</span>evin
      <span className='highlight'>s</span>mith
      <span className='highlight'>w</span>eb
      <span className='highlight'>d</span>ev.com
    </span>
  );
};

export default Logo;